import HeaderComponent from "@/components/partials/HeaderComponent.vue";
import { createI18n } from "vue-i18n";
import en from "./locales/en"
import pt from "./locales/pt"
import es from "./locales/es"

const hostname = window.location.hostname;
let locale = "pt";

if (hostname.endsWith(".com.br")) {
  locale = "pt";
} else if (hostname.endsWith(".com")) {
  locale = "en";
} else if (hostname.endsWith(".com.es")) {
  locale = "es";
}

const messages = {en, pt, es};

const i18n = createI18n({
  locale,
  fallbackLocale: "pt",
  messages,
});

export default i18n;
